import {GoogleMeetIcon} from 'shells/icon/svg/google-meet-icon';
// @ts-expect-error - imported from .js/.jsx file
import {InboundCallIcon} from 'shells/icon/svg/inbound-call-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MapPinIcon} from 'shells/icon/svg/map-pin-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MicrosoftTeamsIcon} from 'shells/icon/svg/microsoft-teams-icon';
// @ts-expect-error - imported from .js/.jsx file
import {OutboundCallIcon} from 'shells/icon/svg/outbound-call-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ZoomIcon} from 'shells/icon/svg/zoom-icon';

import {ConferencingModalWrapper} from './conferencing-modals/conferencing-modal-wrapper';
import {SmallModalWrapper} from './small-modal-wrapper';

export const LOCATION_OPTIONS = [
    {
        value: 'ADDRESS',
        label: 'Address or place',
        sublabel: 'An actual location where the meeting will take place',
        icon: MapPinIcon,
    },
    {
        value: 'OUTBOUND_CALL',
        label: 'Outbound phone call',
        sublabel: 'You call your participant',
        icon: OutboundCallIcon,
    },
    {
        value: 'INBOUND_CALL',
        label: 'Inbound phone call',
        sublabel: 'Your meeting participant will call you',
        icon: InboundCallIcon,
    },
    {
        value: 'TEAMS',
        label: 'Microsoft Teams',
        sublabel: 'Links provided for each booking',
        icon: MicrosoftTeamsIcon,
    },
    {
        value: 'ZOOM',
        label: 'Zoom',
        sublabel: 'Links provided for each booking',
        icon: ZoomIcon,
    },
    {
        value: 'MEET',
        label: 'Google Meet',
        sublabel: 'Links provided for each booking',
        icon: GoogleMeetIcon,
    },
] as const;

export const MODAL_MAP = {
    ADDRESS: SmallModalWrapper,
    OUTBOUND_CALL: SmallModalWrapper,
    INBOUND_CALL: SmallModalWrapper,
    ZOOM: ConferencingModalWrapper,
    MEET: ConferencingModalWrapper,
    TEAMS: ConferencingModalWrapper,
} as const;
